/**
 * Centralised TanStack Query keys for the store-settings feature.
 *
 * Keys are namespaced under `store-settings` so the whole feature can be
 * invalidated at once (e.g. on tenant switch) and individual resources stay
 * cache-isolated. Provider lists are nested under their owning domain.
 */

export const SETTINGS_ROOT_KEY = 'store-settings';

export const settingsKeys = {
  /** Root key — invalidate to drop every settings resource (e.g. tenant switch). */
  all: [SETTINGS_ROOT_KEY] as const,

  general: [SETTINGS_ROOT_KEY, 'general'] as const,

  delivery: [SETTINGS_ROOT_KEY, 'delivery'] as const,
  deliveryProviders: [SETTINGS_ROOT_KEY, 'delivery', 'providers'] as const,

  payments: [SETTINGS_ROOT_KEY, 'payments'] as const,
  paymentProviders: [SETTINGS_ROOT_KEY, 'payments', 'providers'] as const,

  checkout: [SETTINGS_ROOT_KEY, 'checkout'] as const,

  orders: [SETTINGS_ROOT_KEY, 'orders'] as const,
  ordersLifecycle: [SETTINGS_ROOT_KEY, 'orders', 'lifecycle'] as const,

  pricing: [SETTINGS_ROOT_KEY, 'pricing'] as const,

  catalog: [SETTINGS_ROOT_KEY, 'catalog'] as const,

  customers: [SETTINGS_ROOT_KEY, 'customers'] as const,

  notifications: [SETTINGS_ROOT_KEY, 'notifications'] as const,
  notificationProviders: [SETTINGS_ROOT_KEY, 'notifications', 'providers'] as const,

  content: [SETTINGS_ROOT_KEY, 'content'] as const,

  engagement: [SETTINGS_ROOT_KEY, 'engagement'] as const,

  telegram: [SETTINGS_ROOT_KEY, 'telegram'] as const,
  max: [SETTINGS_ROOT_KEY, 'max'] as const,

  telegramMessages: (locale = 'ru') => [SETTINGS_ROOT_KEY, 'telegram', 'messages', locale] as const,
  telegramMessagesFaq: (locale = 'ru') =>
    [SETTINGS_ROOT_KEY, 'telegram', 'messages', 'faq', locale] as const,

  // ── Platform services added in docs/obzr-ecom-platform.md ──────────────────
  tenant: [SETTINGS_ROOT_KEY, 'tenant'] as const,
  store: [SETTINGS_ROOT_KEY, 'store'] as const,
  storeLocations: (params?: unknown) => [SETTINGS_ROOT_KEY, 'store', 'locations', params] as const,
  storeRegions: (params?: unknown) => [SETTINGS_ROOT_KEY, 'store', 'regions', params] as const,
  storeAssignments: [SETTINGS_ROOT_KEY, 'store', 'assignments'] as const,
  storeServiceSettings: [SETTINGS_ROOT_KEY, 'store', 'service-settings'] as const,
  address: [SETTINGS_ROOT_KEY, 'address'] as const,
  inventory: [SETTINGS_ROOT_KEY, 'inventory'] as const,
  media: [SETTINGS_ROOT_KEY, 'media'] as const,
  aiAgents: [SETTINGS_ROOT_KEY, 'ai-agents'] as const,
  basket: [SETTINGS_ROOT_KEY, 'basket'] as const,
} as const;
